/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
type State = Object;

import {
	SET_PROFILE_FETCH_FINISHED,
	SET_PROFILE_TIMEOUT_OR_ERROR,
	SET_PROFILE,
	SET_PAGE_VISIT_COUNT,
	SET_THOR_PRODUCT_LIST,
	SET_RAW_PROFILE,
} from '../types';

const initialState: {
	profileFetchFinished: boolean;
	profileTimeoutOrError: boolean;
	productEntitlements: Array<string>;
	fulfilledEntitlements: Array<string>;
	subscriptionInfo: SubscriptionInfoType;
	storage: Object;
	thorProductList: Object;
	gqlProfile: Object;
} = {
	profileFetchFinished: false, // Indicates if the profile fetch has finished (whether in error or success).
	profileTimeoutOrError: false, // Indicates if the profile fetch resulted in a timeout or error.
	productEntitlements: [], // Array of entitlements for the user.
	fulfilledEntitlements: [], // Array of fulfilled or enabled entitlements for the user. This array is only meaningful for Enterprise customers as only Enterprises have configurable services, it is an empty array for Individual, Team users.
	subscriptionInfo: {}, // Collection of subscription information for the user.
	storage: {},
	thorProductList: {},
	gqlProfile: {},
};

export default (state: State = initialState, action: ProfileAction) => {
	switch (action.type) {
		case SET_PROFILE_FETCH_FINISHED:
			return Object.assign({}, state, {
				profileFetchFinished: action.payload,
			});
		case SET_PROFILE_TIMEOUT_OR_ERROR:
			return Object.assign({}, state, {
				profileTimeoutOrError: action.payload,
			});
		case SET_PROFILE:
			return Object.assign({}, state, {
				creativeProfile: action.payload.creativeProfile,
				productEntitlements: action.payload.entitlements,
				fulfilledEntitlements: action.payload.fulfilledEntitlements,
				subscriptionInfo: action.payload.subscription,
				storage: action.payload.storage,
			});
		case SET_RAW_PROFILE:
			return Object.assign({}, state, {
				gqlProfile: action.payload,
			});
		case SET_THOR_PRODUCT_LIST:
			return Object.assign({}, state, {
				thorProductList: { ...action.payload },
			});
		default:
			return state;
	}
};
